<template>
  <div style=" width: 80%;margin: 0 auto;padding-bottom: 50px;">
      <div class="account-add">
        <div class="account-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="原密码：" prop="password">
              <Input type="text" v-model="formInline.password" placeholder="请输入原密码" />
            </FormItem>
            <FormItem label="新密码：" prop="repassword">
              <Input type="text" v-model="formInline.repassword" placeholder="请输入新密码" />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer" class="btns">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">保存</Button>
        <!-- <Button @click="cancel">取消</Button> -->
      </div>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapGetters } from "vuex";

export default {
  // 修改密码
  name: "changePassword",
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formInline.password) {
        callback(new Error("两次密码不匹配!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      showModal: false,
      formInline: {
        // form双向绑定
        password: "",
        repassword: ""
      }, 
      ruleInline: {
        // 效验规则
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        repassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const regex = /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*\d)(?=.*[\W_])|(?=.*[A-Z])(?=.*\d)(?=.*[\W_])).{8,}$/;
              if (!value) {
                callback("请输入密码(密码均应在8位以上，并具有大小写字母、数字、符号等至少两种以上的组合)");
              } else if (regex.test(value)) {
                callback();
              } else {
                callback("密码均应在8位以上，并具有大小写字母、数字、符号等至少两种以上的组合");
              }
            },
            trigger: "blur"
          }
        ],
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo"
    })
  },
  created() {},
  methods: {
    ...mapActions({
      getStaffByCompId: "companyModule/getStaffByCompId",
      changePasswordByOld: "loginModule/changePasswordByOld"
    }),
    async init() {
      let arr = [];
      let staffArr = await this.getStaffByCompId(this.company.id);
      staffArr.forEach(c => {
        // if (c.roleId === 1) {
          this.adminInfo = c;
        // }
      });
    },
    async handleSubmit(name) {
      
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let formData = {
        UserId: this.user.id,
        JoinId: this.joinInfo.joinId,
        CurrentPassword: form.password,
        NewPassword: form.repassword
      };
      let bool = await this.changePasswordByOld(formData);
      if (!bool) {
        this.$Message.error("修改失败，请重新尝试!");
        return false;
      }
      if (bool.errors && bool.errors[0]) { 
        if (bool.errors[0].code === -1) {
          this.$Message.error("密码有误，请确认修改");
          return;
        }
        this.$Message.error(bool.errors[0].description);
        return;
      }
      this.$emit("closed",form.repassword);
      
      this.cancel();
      
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      // this.showModal = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      // this.$emit("finish");
      // this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-message {
  z-index: 9999 !important; /* 提高 z-index 值 */
}
.account-add {
  padding: 20px 0 40px 0;
  width: 80%;
  margin: 0 auto;
}
.btns{
  margin: 0 auto;
  display: flex;
  justify-content: center;
  button {
    padding: 0 20px;
    margin: 0 20px;
  }
}
</style>

